// Generated by purs version 0.14.3
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Apply = require("../Control.Apply/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Error_Util = require("../Control.Error.Util/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Network_Ethereum_Web3_Solidity_AbiEncoding = require("../Network.Ethereum.Web3.Solidity.AbiEncoding/index.js");
var Network_Ethereum_Web3_Solidity_Generic = require("../Network.Ethereum.Web3.Solidity.Generic/index.js");
var Record_Builder = require("../Record.Builder/index.js");
var Type_Proxy = require("../Type.Proxy/index.js");
var IndexedEvent = function (isAnonymous) {
    this.isAnonymous = isAnonymous;
};
var Event = (function () {
    function Event(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Event.create = function (value0) {
        return function (value1) {
            return new Event(value0, value1);
        };
    };
    return Event;
})();
var DecodeEvent = function (IndexedEvent0, decodeEvent) {
    this.IndexedEvent0 = IndexedEvent0;
    this.decodeEvent = decodeEvent;
};
var ArrayParser = function (arrayParser) {
    this.arrayParser = arrayParser;
};
var isAnonymous = function (dict) {
    return dict.isAnonymous;
};
var decodeEvent = function (dict) {
    return dict.decodeEvent;
};
var combineChange = function (dictRecordFieldsIso) {
    return function (dictGeneric) {
        return function (dictRecordFieldsIso1) {
            return function (dictGeneric1) {
                return function (dictUnion) {
                    return function (dictNub) {
                        return function (dictNewtype) {
                            return function (v) {
                                return Data_Newtype.wrap()(Record_Builder.build(Record_Builder.merge()()(Network_Ethereum_Web3_Solidity_Generic.genericToRecordFields(dictRecordFieldsIso)(dictGeneric)(v.value0)))(Network_Ethereum_Web3_Solidity_Generic.genericToRecordFields(dictRecordFieldsIso1)(dictGeneric1)(v.value1)));
                            };
                        };
                    };
                };
            };
        };
    };
};
var arrayParserNoArgs = new ArrayParser(function (v) {
    return new Data_Maybe.Just(Data_Generic_Rep.NoArguments.value);
});
var arrayParserBase = function (dictABIDecode) {
    return new ArrayParser(function (hxs) {
        var v = Data_Array.uncons(hxs);
        if (v instanceof Data_Maybe.Nothing) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Data_Maybe.Just) {
            return Data_Functor.map(Data_Maybe.functorMaybe)(Data_Generic_Rep.Argument)(Control_Error_Util.hush(Network_Ethereum_Web3_Solidity_AbiEncoding.fromData(dictABIDecode)(v.value0.head)));
        };
        throw new Error("Failed pattern match at Network.Ethereum.Web3.Solidity.Event (line 36, column 21 - line 38, column 63): " + [ v.constructor.name ]);
    });
};
var arrayParser = function (dict) {
    return dict.arrayParser;
};
var arrayParserConstructor = function (dictArrayParser) {
    return new ArrayParser((function () {
        var $60 = Data_Functor.map(Data_Maybe.functorMaybe)(Data_Generic_Rep.Constructor);
        var $61 = arrayParser(dictArrayParser);
        return function ($62) {
            return $60($61($62));
        };
    })());
};
var arrayParserInductive = function (dictArrayParser) {
    return function (dictABIDecode) {
        return new ArrayParser(function (hxs) {
            var v = Data_Array.uncons(hxs);
            if (v instanceof Data_Maybe.Nothing) {
                return Data_Maybe.Nothing.value;
            };
            if (v instanceof Data_Maybe.Just) {
                return Control_Apply.apply(Data_Maybe.applyMaybe)(Data_Functor.map(Data_Maybe.functorMaybe)(Data_Generic_Rep.Product.create)(Data_Functor.map(Data_Maybe.functorMaybe)(Data_Generic_Rep.Argument)(Control_Error_Util.hush(Network_Ethereum_Web3_Solidity_AbiEncoding.fromData(dictABIDecode)(v.value0.head)))))(arrayParser(dictArrayParser)(v.value0.tail));
            };
            throw new Error("Failed pattern match at Network.Ethereum.Web3.Solidity.Event (line 41, column 21 - line 43, column 104): " + [ v.constructor.name ]);
        });
    };
};
var genericArrayParser = function (dictGeneric) {
    return function (dictArrayParser) {
        var $63 = Data_Functor.map(Data_Maybe.functorMaybe)(Data_Generic_Rep.to(dictGeneric));
        var $64 = arrayParser(dictArrayParser);
        return function ($65) {
            return $63($64($65));
        };
    };
};
var parseChange = function (dictGeneric) {
    return function (dictArrayParser) {
        return function (dictGeneric1) {
            return function (dictGenericABIDecode) {
                return function (v) {
                    return function (anonymous) {
                        return Control_Bind.bind(Data_Maybe.bindMaybe)((function () {
                            if (anonymous) {
                                return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(v.topics);
                            };
                            return Data_Functor.map(Data_Maybe.functorMaybe)(function (v1) {
                                return v1.tail;
                            })(Data_Array.uncons(v.topics));
                        })())(function (topics) {
                            return Control_Bind.bind(Data_Maybe.bindMaybe)(genericArrayParser(dictGeneric)(dictArrayParser)(topics))(function (a) {
                                return Control_Bind.bind(Data_Maybe.bindMaybe)(Control_Error_Util.hush(Network_Ethereum_Web3_Solidity_Generic.genericFromData(dictGeneric1)(dictGenericABIDecode)(v.data)))(function (b) {
                                    return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(new Event(a, b));
                                });
                            });
                        });
                    };
                };
            };
        };
    };
};
var decodeEventDef = function (dictArrayParser) {
    return function (dictRecordFieldsIso) {
        return function (dictGeneric) {
            return function (dictRecordFieldsIso1) {
                return function (dictGeneric1) {
                    return function (dictGenericABIDecode) {
                        return function (dictUnion) {
                            return function (dictNub) {
                                return function (dictNewtype) {
                                    return function (dictIndexedEvent) {
                                        return function (change) {
                                            var anonymous = isAnonymous(dictIndexedEvent)(Type_Proxy["Proxy"].value);
                                            return Control_Bind.bind(Data_Maybe.bindMaybe)(parseChange(dictGeneric)(arrayParserConstructor(dictArrayParser))(dictGeneric1)(Network_Ethereum_Web3_Solidity_Generic.abiDecodeConstructor(dictGenericABIDecode))(change)(anonymous))(function (v) {
                                                return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(combineChange(dictRecordFieldsIso)(dictGeneric)(dictRecordFieldsIso1)(dictGeneric1)()()()(v));
                                            });
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var defaultInstance = function (dictArrayParser) {
    return function (dictRecordFieldsIso) {
        return function (dictGeneric) {
            return function (dictRecordFieldsIso1) {
                return function (dictGeneric1) {
                    return function (dictGenericABIDecode) {
                        return function (dictUnion) {
                            return function (dictNub) {
                                return function (dictNewtype) {
                                    return function (dictIndexedEvent) {
                                        return new DecodeEvent(function () {
                                            return dictIndexedEvent;
                                        }, decodeEventDef(dictArrayParser)(dictRecordFieldsIso)(dictGeneric)(dictRecordFieldsIso1)(dictGeneric1)(dictGenericABIDecode)()()()(dictIndexedEvent));
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
module.exports = {
    DecodeEvent: DecodeEvent,
    decodeEvent: decodeEvent,
    decodeEventDef: decodeEventDef,
    ArrayParser: ArrayParser,
    arrayParser: arrayParser,
    genericArrayParser: genericArrayParser,
    IndexedEvent: IndexedEvent,
    isAnonymous: isAnonymous,
    arrayParserNoArgs: arrayParserNoArgs,
    arrayParserBase: arrayParserBase,
    arrayParserInductive: arrayParserInductive,
    arrayParserConstructor: arrayParserConstructor,
    defaultInstance: defaultInstance
};
